import HomeFilled from "@mui/icons-material/HomeFilled";
import LocationOn from "@mui/icons-material/LocationOn";
import Map from "@mui/icons-material/Map";
import People from "@mui/icons-material/People";

export const Permissions = {
  ADMIN: "a",
  USER: "u",
} as const;

export type Permission = (typeof Permissions)[keyof typeof Permissions];

export const allPermissions: Permission[] = Object.values(Permissions);

export type AppPage = "" | "locations" | "map" | "users";

export type AppPageInfo = {
  Icon: React.ComponentType;
  label: string;
  permissions: Permission[];
  workflowContent?: string;
  workflowLabel?: string;
};

export const appPages: Record<AppPage, AppPageInfo> = {
  "": {
    Icon: HomeFilled,
    label: "Home",
    permissions: allPermissions,
  },
  locations: {
    Icon: LocationOn,
    label: "Locations",
    permissions: allPermissions,
    workflowContent: "View available locations.",
    workflowLabel: "Locations",
  },
  map: {
    Icon: Map,
    label: "Trial Map",
    permissions: allPermissions,
    workflowContent: "Upload, view and manage orthos.",
    workflowLabel: "Trial Map",
  },
  users: {
    Icon: People,
    label: "Manage Users",
    permissions: [Permissions.ADMIN],
    workflowContent: "Assign permissions to registered users.",
    workflowLabel: "Manage Users",
  },
} as const;

const basePagePermissions: Record<string, Permission[]> = Object.keys(
  appPages,
).reduce(
  (acc, path) => ({
    ...acc,
    [path]: appPages[path as AppPage].permissions,
  }),
  {} as Record<string, Permission[]>,
);

export const allPagePermissions: Record<string, Permission[]> = {
  ...basePagePermissions,
};

export const workflowOrder: AppPage[] = ["locations", "map", "users"];

export const pageNavOrder: AppPage[] = ["", ...workflowOrder];

export const APP_TITLE = "PepsiCo Geospatial UAV UI";

export const NON_PROD_URL_PREFIX = "https://geo-uav-np.imuto.ai";
